<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <span>
        خرید شارژ پیامک
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form #f="ngForm">
    <div mat-dialog-content class="matDialogContent">
        <div class="container-fluid">
            <div class="row" style="padding: 1rem 0;">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 charge">
                    <span>شارژ پنل پیامک</span>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 charge">
                    <input class="wh-input center" name="amount" (keyup)="get_charge2()" [(ngModel)]="amount" required
                        currencyMask placeholder="حداقل شارژ 100،0000 ریال">
                </div>
                <div class="col-xl-12 col-lg-12 col-sm-12 col-xs-12 charge2" *ngIf="amount2 > 0">
                    با احتساب ارزش افزوده :
                    {{ amount2 | number}}
                    ریال
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 center">
                    <button type="button" class="btn_pe" (click)="charge()"
                        [disabled]="!f.valid || amount < 1000 || loading2">
                        <span *ngIf="!loading2">پرداخت</span>
                        <span *ngIf="loading2" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>